var _defs, _polyline, _path, _g, _g2, _path2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZapdesignBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "text-paolozap-03",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.97 75.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        ", "\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        ", "\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.8 14.37 53.33 9.17 7.8 61.2 62.43 44.94 83.89 9.17 103.29 63.64 114.89 64.01 114.89 29.04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-1",
    d: "M143.31,8.37h1.61c15.31,0,28.19,12.53,27.86,27.83-.32,14.79-12.38,27.81-27.22,27.81h-4.23c-2.55,0-4.62-2.07-4.62-4.62v-20.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P_copy_2",
    "data-name": "P copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.56,29.06c7.17,0,12.98-4.47,12.98-9.98s-5.81-9.98-12.98-9.98h-11.57"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e_1",
    "data-name": "e 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.86,
    y1: 26.59,
    x2: 209.07,
    y2: 19.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.78,41.27c15.19-3.69,30.48-9.97,46.39-8.74,6,.46,11.93,2.18,17.11,5.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.81,8.34c-.3,.01-.64-.05-1.01-.19-.37-.14-.74-.26-1.1-.36-1.04-.32-2.3-.65-3.77-.98-5.26-1.2-11.63-.49-14.83,4.33-1.67,2.51-1.04,5.16,1.1,7.19,2.13,2.02,5,3.05,7.84,3.82,4.52,1.22,9.53,2.15,12.81,5.82,2.67,2.99,3.87,7.25,3.86,11.2,.07,1.81-.22,3.49-.89,5.04-2.03,4.72-6.81,7.4-11.86,7.01-3.26-.25-6.37-1.44-9.5-2.39-14.1-4.29-27.68,.94-41.45,4.29l-25.82,6.28"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.8,59.39c.43-3.38,1.83-6.53,2.11-9.93,.58-7.06-3.1-12.22-6.24-18.16l24.31,28.09V6.29"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "G_copy",
    "data-name": "G copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.04,45.94c-2.23-1.66-4.3-3.65-5.45-6.18s-1.23-5.67,.34-7.96c2.17-3.16,6.88-3.74,10.36-2.12s5.87,4.91,7.63,8.32c1.82,3.53,3.13,7.51,2.52,11.43-1.24,7.9-9.99,12.7-17.99,12.74-4.11,.02-8.28-.91-11.75-3.11-8.37-5.29-10.85-16.55-9.89-26.4,.48-4.88,1.64-9.77,4.16-13.97s6.52-7.66,11.28-8.81c5.79-1.39,11.97,.79,16.72,4.39,7.35,5.58,12.33,14.15,18.17,21.19,6.76,8.14,13.91,15.94,20.83,23.93"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.86,22.84c-2.44,5.38-5.37,16.11,0,22.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapdesignBlack);
export default __webpack_public_path__ + "static/media/zapdesign-black.6bcb6ceab6e5d7016f93874352789d93.svg";
export { ForwardRef as ReactComponent };